var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-doc row"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('bs-nav', {
    staticClass: "flex-column",
    attrs: {
      "pill": ""
    },
    model: {
      value: (_vm.activedIndex),
      callback: function($$v) {
        _vm.activedIndex = $$v
      },
      expression: "activedIndex"
    }
  }, _vm._l((_vm.computedTabs), function(tab, index) {
    return _c('bs-nav-item', {
      key: tab
    }, [_vm._v(_vm._s(tab))])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('bs-nav-content', {
    attrs: {
      "value": _vm.activedIndex
    }
  }, _vm._l((_vm.computedTabs), function(tab, index) {
    return _c('bs-nav-pane', {
      key: tab,
      ref: "pane",
      refInFor: true
    })
  }))], 1), _vm._v(" "), _vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dfddf69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/components/ComponentDoc.vue
// module id = 204
// module chunks = 19